// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5018": "f3aebcddaad9","6863": "454c9f289029","7522": "4bd9607450b8","8357": "dd422574e14d","8990": "7d69c8cdd354",}[chunkId] + ".css"
}